// Single source of truth for all editable site content.
// The same shape is seeded into MongoDB on backend startup and used as a fallback
// in case the API is unavailable. Admin can override any field via /admin/icerik.

export const DEFAULT_CONTENT = {
  brand: { name: "ÖZKAYALAR", sub: "inşaat" },

  colors: {
    ivory: "#fdfbf7",
    cream: "#f5f2eb",
    stone: "#eae4d3",
    gold: "#c5a059",
    navy: "#0a192f",
    ink: "#1a202c",
    slate: "#4a5568",
  },

  contact: {
    phone_display: "+90 507 924 08 26",
    whatsapp_number: "905079240826",
    email: "info@ozkayalarinsaat.com",
    address: "İzmir / Menemen — 29 Ekim Mah. 7301 Sok. No:6",
    instagram_handle: "ozkayalarinsaat35",
    instagram_url: "https://instagram.com/ozkayalarinsaat35",
    map_embed_src:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1560.2224433433503!2d27.047645869882086!3d38.546562545673304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbd113c22df72f%3A0xcc2d62e6167b8054!2sUlukent%20Park!5e0!3m2!1str!2str!4v1780435551100!5m2!1str!2str",
    default_whatsapp_message: "Merhaba, projeleriniz hakkında bilgi almak istiyorum.",
  },

  navbar: {
    link_home: "Ana Sayfa",
    link_projects: "Projeler",
    link_about: "Hakkımızda",
    link_contact: "İletişim",
    cta_label: "İletişime Geç",
  },

  footer: {
    tagline:
      "İnce işçilik, seçkin malzeme ve zamansız tasarımlarla fark yaratan yaşam alanları. Kalite, güven ve değer odaklı yapı anlayışıyla geleceğe değer katıyoruz.",
    explore_title: "Keşfet",
    contact_title: "İletişim",
    address_short: "İzmir / Menemen",
    copyright: "Tüm hakları saklıdır.",
    admin_link_label: "Yönetim",
  },

  home: {
    hero: {
      eyebrow: "Özkayalar İnşaat",
      title_line1: "Prestijli Yaşamın",
      title_italic: "Yeni Adresi.",
      subtitle:
        "İnce işçilik, seçkin malzeme ve zamansız tasarımla şehir hayatına değer katan modern yaşam alanları. Her detayda kalite ve zarafet.",
      cta1_label: "Projelerimizi İncele",
      cta2_label: "İletişime Geç",
      scroll_hint: "Keşfet ↓",
    },
    about: {
      eyebrow: "Biz Kimiz?",
      heading_line1: "Her detayda",
      heading_italic: "kalite",
      heading_line2: "ve zarafet.",
      body:
        "2010 yılından bu yana inşaat sektöründe faaliyet gösteren Özkayalar İnşaat, estetik, konfor ve yatırım değerini bir araya getiren prestijli projelere imza atıyor. Modern mimari anlayışı, kaliteli malzeme seçimi ve müşteri odaklı yaklaşımıyla geleceğe değer katıyoruz.",
      link_label: "Daha Fazla Bilgi",
      image:
        "https://customer-assets.emergentagent.com/job_b9a69ad1-4ed0-4490-95c1-77b4598aad78/artifacts/u8v1tmoq_ChatGPT%20Image%2025%20May%202026%2015_54_00%20%287%29.png",
    },
    stats: [
      { number: "15+", label: "Yıllık Tecrübe", note: "Kuruluş 2010" },
      { number: "12", label: "Tamamlanan Proje", note: "Kaliteli Teslim" },
      { number: "1", label: "Devam Eden Proje", note: "Aktif Şantiye" },
      { number: "35", label: "Hizmet Bölgesi", note: "İzmir ve Çevresi" },
    ],
    projects_section: {
      eyebrow: "Projelerimiz",
      heading_line1: "Geleceğe değer katan",
      heading_italic: "projeler",
      view_all_label: "Tüm Projeleri Gör",
      loading_text: "Projeler yükleniyor…",
    },
    why_us: {
      eyebrow: "Neden Özkayalar?",
      heading_line1: "Modern mimari,",
      heading_italic: "seçkin detaylar",
      body:
        "Kaliteli mimari, konforlu yaşam ve güvenli yapılar; üç temel söz, sayısız detay. Her projemizde aynı titizliği ve aynı zarafeti koruyoruz.",
      features: [
        { icon: "Building2", title: "Modern Mimari", desc: "Çağdaş çizgiler, prestijli cephe tasarımları ve zamansız estetik." },
        { icon: "ShieldCheck", title: "Güvenli Yapılar", desc: "Deprem yönetmeliğine uygun, üst seviye mühendislik standartları." },
        { icon: "Sparkles", title: "Seçkin Detaylar", desc: "İnce işçilik, premium malzeme seçimi ve detaylara verilen önem." },
      ],
    },
    social: {
      eyebrow: "Şehrin İçinde",
      heading_line1: "Ayrıcalıklı",
      heading_italic: "bir dünya",
      body:
        "Havuz, fitness, yeşil alanlar ve kafe-lounge; her projemizde modern yaşamın gerektirdiği seçkin sosyal alanları tasarlıyoruz.",
      image:
        "https://customer-assets.emergentagent.com/job_b9a69ad1-4ed0-4490-95c1-77b4598aad78/artifacts/mg5cstxf_ChatGPT%20Image%2025%20May%202026%2015_53_59%20%285%29.png",
      amenities: [
        { icon: "Waves", label: "Havuz" },
        { icon: "Dumbbell", label: "Fitness" },
        { icon: "TreePine", label: "Yeşil Alan" },
        { icon: "Coffee", label: "Kafe & Lounge" },
      ],
    },
    final_cta: {
      eyebrow: "Bir sonraki adım",
      heading_line1: "Geleceğinizi bizimle",
      heading_italic: "inşa edin",
      body: "Proje detayları, lokasyon avantajları ve daire seçenekleri için bizimle iletişime geçin.",
      cta1_label: "İletişime Geç",
      cta2_label: "WhatsApp ile Yaz",
    },
  },

  projects_page: {
    eyebrow: "Projelerimiz",
    heading_line1: "Geleceğe değer katan",
    heading_italic: "eserler",
    body:
      "Tamamladığımız ve hâlâ inşa etmekte olduğumuz projelerimizle prestijli yaşam anlayışımızı keşfedin.",
    filter_all: "Tümü",
    filter_ongoing: "Devam Eden",
    filter_completed: "Tamamlanan",
    loading_text: "Yükleniyor…",
    empty_text: "Bu kategoride proje bulunmuyor.",
  },

  about_page: {
    hero: {
      eyebrow: "Hakkımızda",
      heading_line1: "Biz",
      heading_italic: "kimiz?",
      body_p1:
        "Özkayalar İnşaat, 2010 yılından bu yana inşaat sektöründe faaliyet gösteren, modern mimari anlayışı ile prestijli projelere imza atan bir aile şirketidir. Yıllar içinde edindiğimiz deneyim, kaliteli malzeme seçimi ve müşteri memnuniyeti odaklı yaklaşımımızla; konfor, estetik ve güvenliği bir araya getiren yaşam alanları üretiyoruz.",
      body_p2:
        "İzmir ve Ege bölgesinde tamamladığımız projelerle binlerce aileye sıcak yuva, yatırımcılara değer kazanan gayrimenkul sunduk.",
      image:
        "https://customer-assets.emergentagent.com/job_b9a69ad1-4ed0-4490-95c1-77b4598aad78/artifacts/x0unv2cf_ChatGPT%20Image%2025%20May%202026%2015_53_53%20%281%29.png",
    },
    founding_story: {
      eyebrow: "Kuruluş Hikayemiz",
      heading_line1: "15 yılı aşan",
      heading_italic: "deneyim",
      body_p1:
        "Özkayalar İnşaat, ailesinin köklü inşaat geleneğini modern mimari anlayışla buluşturarak 2010 yılında kuruldu. İlk projelerden bu yana taşıdığımız temel ilke aynı: zamansız tasarım, kaliteli işçilik ve müşterilerimize verilen sözün ardında durmak.",
      body_p2:
        "Bugün hem konut hem ticari projelerde imzamızı taşıyan yapılarla; sektörde kalite ve güvenin sembolü olmayı sürdürüyoruz.",
    },
    pillars: [
      { icon: "Compass", title: "Misyon", text: "Kalite, güven ve estetik anlayışını ön planda tutan modern yaşam alanları üretmek; müşterilerimize değer katan projeler sunmak." },
      { icon: "Target", title: "Vizyon", text: "Türkiye'nin inşaat sektöründe yenilikçi mimari, kaliteli işçilik ve zamansız tasarım anlayışıyla referans gösterilen bir marka olmak." },
      { icon: "Heart", title: "Yapı Anlayışımız", text: "Her detayı titizlikle ele alır, seçkin malzeme ve usta işçilikle uzun ömürlü, zamansız yapılar inşa ederiz." },
      { icon: "ShieldCheck", title: "Kalite ve Güven", text: "Tüm projelerimizde deprem yönetmeliğine uygun mühendislik, sertifikalı malzeme ve şeffaf süreçlerle güven veriyoruz." },
    ],
    award_stats: [
      { icon: "Building2", number: "15+", label: "Yıllık Tecrübe" },
      { icon: "Award", number: "12", label: "Tamamlanan Proje" },
      { icon: "ShieldCheck", number: "100%", label: "Müşteri Memnuniyeti" },
      { icon: "Heart", number: "1500+", label: "Mutlu Aile" },
    ],
  },

  contact_page: {
    eyebrow: "İletişim",
    heading_line1: "Bir sonraki adımı",
    heading_italic: "birlikte atalım",
    body:
      "Projelerimiz hakkında bilgi almak, satış ofisimizi ziyaret etmek veya iş birliği görüşmek için bize ulaşın.",
    form_title: "Bize Yazın",
    form_subtitle: "Formu doldurun, WhatsApp üzerinden hızlıca iletişime geçelim.",
    label_name: "Ad Soyad *",
    placeholder_name: "Adınız Soyadınız",
    label_phone: "Telefon *",
    placeholder_phone: "+90 5xx xxx xx xx",
    label_project: "İlgilenilen Proje",
    select_default: "Seçim yapın",
    select_general: "Genel Bilgi",
    label_message: "Mesajınız",
    placeholder_message: "Mesajınızı buraya yazın...",
    submit_label: "WhatsApp ile Gönder",
    submit_note: "Form WhatsApp üzerinden iletilir.",
    sidebar_eyebrow: "İletişim Bilgileri",
    sidebar_heading: "Bize ulaşın",
  },

  project_detail: {
    back_label: "Tüm Projeler",
    info_cta_label: "Bilgi Al",
    contact_cta_label: "İletişim Formu",
    about_eyebrow: "Proje Hakkında",
    about_heading_line1: "Modern mimari,",
    about_heading_italic: "prestijli yaşam",
    features_title: "Proje Özellikleri",
    social_eyebrow: "Seçkin Sosyal Alanlar",
    social_heading: "Ayrıcalıklı bir dünya",
    location_eyebrow: "Konum Avantajları",
    location_heading: "Merkezi konum",
    gallery_eyebrow: "Görsel Galeri",
    gallery_heading_line1: "Mimari",
    gallery_heading_italic: "detaylar",
    cta_eyebrow: "Bilgi Al",
    cta_heading_italic: "bilgi alın",
    cta_body: "Daire planları, fiyat seçenekleri ve teslim tarihi için bizimle iletişime geçin.",
    cta_whatsapp_label: "WhatsApp ile İletişim",
    cta_contact_label: "İletişim Formu",
  },
};

export default DEFAULT_CONTENT;
